import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ErrorHandler = (error) => {
  const errMsg =
    error?.message?.message ||
    error?.error?.message ||
    error?.error?.msg ||
    error?.message ||
    error?.msg ||
    error.error ||
    "Unknown Error. Please try again.";
  toast.error(errMsg, { autoClose: 5000 });
  console.log(error);
};

export const UncaughtRejectionHandler = (event) => {
  ErrorHandler(event.reason);
};

export default ErrorHandler;
